export default __webpack_public_path__ + "static/media/img-0289-zambia-full-face.27446da5.png";